import * as React from "react"
import {useEffect} from "react"
import { Box } from "@mui/material"

import {HOME_ROUTES, PRICING_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import {isSystemBusy, retailer} from "@signals";
import {sideComparisonIsEmpty, resetSideComparisonSignals} from "./@signals";
import PricingSideComparisonFilters from "./Filters";
import PricingSideComparisonTable from "./Table";


export default function PricingSideComparisonPage() {

    useEffect(() => {
        return () => resetSideComparisonSignals()
    }, []);

    return <PageWrapper
        tourPageKey="sideComparison"
        head={`DIP Insight | ${PRICING_ROUTES.SIDE_COMPARISON_TITLE}`}
        title={PRICING_ROUTES.SIDE_COMPARISON_TITLE}
        subtitle={PRICING_ROUTES.SIDE_COMPARISON_SUBTITLE}
        filters={<PricingSideComparisonFilters />}
        isEmpty={sideComparisonIsEmpty.value}
        hasErrors={isSystemBusy.value}
    >
        <Box sx={{ position: "relative" }}>
            <TourTarget name="side-comparison-table" height={350} />
            <PricingSideComparisonTable />
        </Box>
    </PageWrapper>
}
